import { render } from "./PriceDisplay.vue?vue&type=template&id=716c86e6&scoped=true"
import script from "./PriceDisplay.vue?vue&type=script&lang=js"
export * from "./PriceDisplay.vue?vue&type=script&lang=js"

import "./PriceDisplay.vue?vue&type=style&index=0&id=716c86e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716c86e6"]])

export default __exports__